export default "__VITE_ASSET__DuKjyArD__"